import React from "react"
import CurvedLineGraph from "./CurvedLineGraph"

const FuelCard = ({ data }) => <CurvedLineGraph name={"fuelCard"} data={data} />

export default FuelCard
